var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PlatformProjectsView"},[_c('ShPageHeader',{attrs:{"title":"Projekty","description":"Poniżej znajduje się lista wszystkich projektów klienta.<br>","breadcrumb-items":[
                  { label: 'zarządzanie' },
                  { label: 'Projekty', path: '/projects' }
                ]}}),_c('ShPageLayout',[_c('ProjectsList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }